export const MY_CATEGORY_BLACK_LIST_PATHS = [
  '/instructor/:slug',
  '/instructor',
  '/create_course',
  '/contract-content',
  '/user/validation',
  '/course/:courseId/edit/*',
];
